import {
  MOCK_CUSTOMER_INSTALL_ONLY_SHIPPING_COST_PER_ACCESSORY,
  MOCK_SELF_INSTALL_OPTION_SHIPPING_COST_PER_ACCESSORY
} from './constants';
import type { AccessoryShippingQuote, AccessoryShippingQuoteRequest } from './types';

const ZIP5_PATTERN = /^\d{5}$/;

export const createMockAccessoryShippingQuote = ({
  accessoryId,
  itemSku,
  installType,
  destinationZip,
  group
}: AccessoryShippingQuoteRequest): AccessoryShippingQuote | null => {
  const normalizedItemSku = itemSku.trim();
  const normalizedZip = destinationZip?.trim() ?? '';

  if (
    installType !== 'CUSTOMER_INSTALL' ||
    !normalizedItemSku ||
    !ZIP5_PATTERN.test(normalizedZip)
  ) {
    return null;
  }

  return {
    key: `${installType}|${normalizedItemSku}|${normalizedZip}`,
    accessoryId,
    itemSku: normalizedItemSku,
    installType,
    destinationZip: normalizedZip,
    amount:
      group === 'SELF_INSTALL_OPTION'
        ? MOCK_SELF_INSTALL_OPTION_SHIPPING_COST_PER_ACCESSORY
        : MOCK_CUSTOMER_INSTALL_ONLY_SHIPPING_COST_PER_ACCESSORY,
    group
  };
};

export const getAccessoryShippingTotal = (quotes: AccessoryShippingQuote[]) =>
  quotes.reduce((total, quote) => total + quote.amount, 0);
